import { Component } from '@angular/core';

@Component({
  selector: 'app-academic-staff',
  templateUrl: './academic-staff.component.html',
  styleUrls: ['./academic-staff.component.scss'],
  standalone: false,
})
export class AcademicStaffComponent {
  benifits = [
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/academic-staff-image-1.png',
      heading: 'Interactive Lesson Planning',
      number: '01',
      description:
        'Create engaging lessons effortlessly with our intuitive planning tools.',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/academic-staff-image-2.png',
      heading: 'Simplified Grading & Assessments',
      number: '02',
      description:
        'Automate grading and provide quick feedback to support student growth.',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/academic-staff-image-3.png',
      heading: 'Real-Time Student Insights',
      number: '03',
      description:
        'Monitor student progress with actionable analytics and reports.',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/academic-staff-image-4.png',
      heading: 'Collaborative Classroom Environment',
      number: '04',
      description:
        'Enhance communication with students through integrated messaging and forums.',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/academic-staff-image-4.png',
      heading: 'Take Attendance',
      number: '05',
      description:
        'Enhance communication with students through integrated messaging and forums.',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/academic-staff-image-4.png',
      heading: 'Manage Timetable',
      number: '06',
      description:
        'Enhance communication with students through integrated messaging and forums.',
    },
  ];
}
